export default "<menu--item>\r\n  <a data-@href=\"@[data-link]\"><img data-@src=\"@[data-icon]\"><item-title>@{}</item-title></a>\r\n</menu--item>";